import { Box, List } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import palette from '@ui/palette';
import Icon from '@ui/Icon';
import Typography from '@ui/Typography';
import DictionarySuggestionListItem from '@replacements/components/ReplacementsDictionary/DictionarySuggestionListItem';
import { SuggestionsByRegion } from '@replacements/context/ReplacementsDictionaryContext';
import { RespellingRegionLabel } from '@replacements/components/ReplacementsDictionary/DictionaryBody';

interface DictionarySuggestionListProps {
  word: string;
  title: string;
  suggestions: SuggestionsByRegion[keyof SuggestionsByRegion];
  location: string;
  replacementInput?: string;
  showBorder: boolean;
}

const useStyles = makeStyles<{ showBorder: boolean }>()(
  (theme, { showBorder }) => ({
    listPadding: {
      padding: theme.spacing(3),
      borderTop: showBorder ? `1px solid ${palette.gray_800}` : 'none',
    },
    suggestionList: {
      display: 'flex',
      flexDirection: 'column',
    },
  })
);

const DictionarySuggestionList = (props: DictionarySuggestionListProps) => {
  const { word, suggestions, location, replacementInput, title, showBorder } =
    props;
  const { classes } = useStyles({ showBorder });
  return (
    <Box>
      <List
        classes={{ padding: classes.listPadding, root: classes.suggestionList }}
        role={'list'}
      >
        <Box
          style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}
        >
          <Icon
            type={
              title === RespellingRegionLabel['English UK']
                ? 'unitedKingdomFlag'
                : 'unitedStatesFlag'
            }
            style={{ paddingRight: '8px' }}
          />
          <Typography variant="pSm" color="secondary">
            {title}
          </Typography>
        </Box>
        {suggestions.map((suggestion, index) => (
          <DictionarySuggestionListItem
            key={`${suggestion.id}:${suggestion.label}`}
            word={word}
            {...suggestion}
            size={suggestions.length}
            position={index + 1}
            location={location}
            isAdded={replacementInput === suggestion.label}
          />
        ))}
      </List>
    </Box>
  );
};

export default DictionarySuggestionList;
